module.exports = __webpack_public_path__ + "img/IMG_1867_L_WoodMatted_MockedUp.cd550b2e.jpg";